<style lang="scss" src='./Courses.scss' scoped></style>
<template src="./Courses.html"></template>

<script>
  import {
    mapState,
    mapActions,
  } from 'vuex';
  
  import i18n from './../../../i18n';

  export default {
    name: 'Courses',
    components: {
    },

    data() {
      return {
        facility_name: null,
      };
    },

    computed: {
      coursesSorted: function() {
        let filteredCourses = []
        if(this.facility_name){
          let name = this.facility_name.toLowerCase();
          filteredCourses = this.courses.filter(
            (course) => 
              course.name && course.name.toLowerCase().includes(name)
            );
        }else{
          filteredCourses = this.courses
        }

        return this.G_sortArr(filteredCourses, 'name');
      },

      ...mapState('Courses', {
        courses: (state) => state.courses,
        loading: (state) => state.loading,
      }),
    },

    methods: {
      GetFacilityName(facility){
        if(!facility){
          return i18n.t('general.golfCourse');
        }
        if(facility.i18n.length > 0){
          let text = facility.i18n.find((item)=>{
            if(item.language == this.$i18n.locale){
              return item
            }    
          })

          if(text){
            return text.i18n
          }else{
            return facility.name
          }
        }else{
          return facility.name
        }
      },

      loadData() {
        this.loadCourses();
      },

      selectCourse(course) {
        this.$router.push(`/setup-course/${course.course_id}`);
      },
      
      ...mapActions('Courses', ['loadCourses']),
    },

    mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Golf Courses");
        this.$analytics.logEvent("web_golf_courses");
      }

      this.loadData();
    },

    beforeDestroy() {
    },
  };

</script>
